export const nl = {
  // ── Navigation ────────────────────────────────────────────────────────────
  "nav.operations": "Operaties",
  "nav.dashboard": "Dashboard",
  "nav.proformas": "Proforma's",
  "nav.documents": "Documenten",
  "nav.administration": "Administratie",
  "nav.users": "Gebruikers",
  "nav.parties": "Partijen",
  "nav.emailAddresses": "E-mailadressen",
  "nav.mainLabel": "Hoofdnavigatie",

  // ── Environment badge ─────────────────────────────────────────────────────
  "env.prod": "PROD",
  "env.acc": "ACC",
  "env.local": "LOCAL",

  // ── Non-production banner ─────────────────────────────────────────────────
  "banner.acc": "Acceptatieomgeving",
  "banner.local": "Ontwikkelomgeving",
  "banner.note": "proforma's en gegevens hier staan los van productie",

  // ── New version deployed while this tab was open ──────────────────────────
  "newVersion.title": "Nieuwe versie beschikbaar.",
  "newVersion.body": "Rond af waar je mee bezig bent en herlaad de pagina om verder te werken.",
  "newVersion.reload": "Herladen",

  // ── Shell ─────────────────────────────────────────────────────────────────
  "shell.expandSidebar": "Zijbalk uitklappen",
  "shell.collapseSidebar": "Zijbalk inklappen",
  "shell.help": "Help",
  "shell.notifications": "Meldingen",

  // ── User menu ─────────────────────────────────────────────────────────────
  "user.unknownUser": "Onbekende gebruiker",
  "user.profile": "Profiel",
  "user.language": "Taal",
  "user.keyboardShortcuts": "Sneltoetsen",
  "user.signOut": "Uitloggen",

  // ── Keyboard shortcuts dialog ─────────────────────────────────────────────
  "kb.title": "Sneltoetsen",
  "kb.close": "Sluiten",
  "kb.groups.global": "Globaal",
  "kb.groups.tables": "Tabellen",
  "kb.groups.general": "Algemeen",
  "kb.shortcuts.openPanel": "Sneltoetsen (dit paneel)",
  "kb.shortcuts.commandPalette": "Commandopalet",
  "kb.shortcuts.nextRow": "Volgende rij",
  "kb.shortcuts.prevRow": "Vorige rij",
  "kb.shortcuts.openRow": "Rij openen",
  "kb.shortcuts.focusSearch": "Zoeken focussen",
  "kb.shortcuts.closePanel": "Paneel sluiten",

  // ── Login ─────────────────────────────────────────────────────────────────
  "login.title": "Inloggen",
  "login.subtitle": "Welkom terug. Log in op het Albert van de Scheur-platform.",
  "login.email": "E-mailadres",
  "login.password": "Wachtwoord",
  "login.forgot": "Vergeten?",
  "login.signIn": "Inloggen",
  "login.or": "of",
  "login.sso": "Single sign-on (SSO)",
  "login.securedPrefix": "Beveiligd met 2FA · ",
  "login.needHelp": "Hulp nodig?",
  "login.brandAlt": "Albert van de Scheur",
  "login.quoteBefore": "Verplaatsen met ",
  "login.quoteAccent": "passie",
  "login.quoteAfter": " — sinds 1934.",
  "login.asideFoot": "Albert van de Scheur · Apeldoorn · Industriële verplaatsingen",
  "login.signInFailed": "Inloggen mislukt. Probeer het opnieuw.",
  "login.devMode": "Ontwikkelmodus — kies rollen en log in",
  "login.signInAsMock": "Inloggen (mock)",
  "login.internalTitle": "Interne medewerkers",
  "login.internalSubtitle": "Log in met uw Albert van de Scheur-account.",
  "login.partnerTitle": "Partners",
  "login.partnerSubtitle": "Log in op het partnerportaal met e-mail en wachtwoord.",
  "login.partnerUnavailable": "Het partnerportaal is nog niet beschikbaar.",

  // ── Common ────────────────────────────────────────────────────────────────
  "common.thisMonth": "Deze maand",
  "common.previous": "Vorige",
  "common.next": "Volgende",
  "common.cancel": "Annuleren",
  "common.close": "Sluiten",
  "common.viewAll": "Alles",
  "common.download": "Downloaden",
  "common.emDash": "—",
  "common.loading": "Laden…",
  "common.retry": "Opnieuw proberen",
  "common.errorTitle": "Er ging iets mis",
  "common.errorDesc": "De gegevens konden niet worden geladen. Probeer het opnieuw.",

  // ── Proforma (shared) ─────────────────────────────────────────────────────
  "proforma.new": "Nieuwe proforma",

  // ── Dashboard ─────────────────────────────────────────────────────────────
  "dashboard.greetingMorning": "Goedemorgen, {{name}}",
  "dashboard.greetingAfternoon": "Goedemiddag, {{name}}",
  "dashboard.greetingEvening": "Goedenavond, {{name}}",
  "dashboard.subtitle_one": "{{date}} · {{count}} proforma vraagt aandacht",
  "dashboard.subtitle_other": "{{date}} · {{count}} proforma's vragen aandacht",
  "dashboard.kpi.open": "Open proforma's",
  "dashboard.kpi.inProgress": "In uitvoering",
  "dashboard.kpi.revenue": "Omzet deze maand",
  "dashboard.kpi.onHold": "Geblokkeerd",
  "dashboard.kpi.openDelta": "▲ 4 t.o.v. vorige week",
  "dashboard.kpi.inProgressDelta": "▲ 2",
  "dashboard.kpi.revenueDelta": "▲ 8,4%",
  "dashboard.kpi.onHoldDelta": "▲ 1 — wacht op klant",
  "dashboard.chart.title": "Aanvragen & omzet",
  "dashboard.chart.subtitle": "Laatste 8 weken",
  "dashboard.chart.requests": "Aanvragen",
  "dashboard.chart.revenue": "Omzet (geïndexeerd)",
  "dashboard.queue.title": "Werkbak",
  "dashboard.alertBefore": "5 proforma's geblokkeerd. ",
  "dashboard.alertText": "Wachten op documenten van de klant. Bekijk de ",
  "dashboard.alertLink": "geblokkeerde lijst",
  "dashboard.alertAfter": " en stuur een herinnering.",

  // ── Proformas list ────────────────────────────────────────────────────────
  "proformas.title": "Proforma's",
  "proformas.summary": "{{total}} totaal · {{open}} open",
  "proformas.tab.all": "Alle",
  "proformas.tab.open": "Open",
  "proformas.tab.inProgress": "In uitvoering",
  "proformas.tab.onHold": "Geblokkeerd",
  "proformas.tab.completed": "Gereed",
  "proformas.search": "Zoek op ordernummer, klant of proformanummer…",
  "proformas.filter.workType": "Type werk",
  "proformas.selectAll": "Alles selecteren",
  "proformas.selectRow": "Rij selecteren",
  "proformas.col.number": "Nummer",
  "proformas.col.customer": "Klant",
  "proformas.col.workType": "Type werk",
  "proformas.col.status": "Status",
  "proformas.col.weight": "Gewicht",
  "proformas.col.amount": "Bedrag",
  "proformas.col.deliveryDate": "Leverdatum",
  "proformas.col.lead": "Projectverantwoordelijke",
  "proformas.count": "{{shown}} van {{total}} proforma's",
  "proformas.pageOf": "{{page}} / {{pages}}",
  "proformas.empty.title": "Geen proforma's gevonden",
  "proformas.empty.desc": "Pas je zoekopdracht of filters aan, of maak een nieuwe proforma aan.",
  "proformas.error.title": "Proforma's konden niet worden geladen",
  "proformas.error.desc": "Er ging iets mis bij het ophalen. Probeer het opnieuw, of meld het met het tijdstip erbij.",
  "proformas.error.forbidden.title": "Je hebt geen toegang tot proforma's",
  "proformas.error.forbidden.desc": "Vraag een beheerder om de rol Projectverantwoordelijke. Dit is geen ontbrekende order — het scherm mag hem niet laten zien.",

  // ── Proforma detail ───────────────────────────────────────────────────────
  "detail.eyebrow": "Proforma · {{number}}",
  "detail.subtitle": "{{location}} · {{weight}} · {{trips}} ritten",
  "detail.pdf": "PDF",
  "detail.more": "Meer",
  "detail.changeStatus": "Status wijzigen",
  "detail.changeStatusTitle": "Status wijzigen",
  "detail.changeStatusReason": "Reden (optioneel)",
  "detail.changeStatusConfirm": "Wijzigen",
  "detail.noTransitions": "Geen statuswijziging mogelijk vanuit deze staat.",
  "detail.transitionFailed": "Statuswijziging mislukt. Probeer het opnieuw.",
  "detail.tab.overview": "Overzicht",
  "detail.tab.documents": "Documenten",
  "detail.tab.timeline": "Tijdlijn",
  "detail.tab.audit": "Audit",
  "detail.card.assignment": "Opdracht",
  "detail.card.documents": "Documenten",
  "detail.card.activities": "Activiteiten",
  "detail.card.timeline": "Tijdlijn",
  "detail.card.contact": "Contact",
  "detail.addDocument": "Toevoegen",
  "detail.kv.workType": "Type werk",
  "detail.kv.customer": "Klant",
  "detail.kv.location": "Locatie",
  "detail.kv.weight": "Gewicht",
  "detail.kv.trips": "Ritten",
  "detail.kv.execution": "Uitvoering",
  "detail.kv.quote": "Offertebedrag",
  "detail.kv.projectLead": "Projectverantwoordelijke",
  "detail.kv.created": "Aangemaakt",
  "detail.contactRole": "{{company}} · Facility",
  "detail.documentsEmpty": "Nog geen documenten. Documenten volgen zodra de module actief is.",
  "detail.auditEmpty": "Het audit-logboek verschijnt hier zodra de API is gekoppeld.",
  "detail.week": "week {{week}} · {{year}}",
  "detail.trips": "{{count}} ritten",

  // ── Intake (4-step) ───────────────────────────────────────────────────────
  "intake.title": "Nieuwe proforma",
  "intake.subtitle": "Proforma's komen normaal uit TALIS. Maak hier handmatig een concept aan.",
  "intake.step.customer": "Klant",
  "intake.step.assignment": "Opdracht",
  "intake.step.specification": "Specificatie",
  "intake.step.confirmation": "Bevestiging",
  "intake.step1.title": "Stap 1 · Klant",
  "intake.step1.subtitle": "Voor wie voeren we het werk uit?",
  "intake.step2.title": "Stap 2 · Opdracht",
  "intake.step2.subtitle": "Wat moet er verplaatst worden?",
  "intake.step3.title": "Stap 3 · Specificatie",
  "intake.step3.subtitle": "Gewicht, planning en bijzonderheden.",
  "intake.step4.title": "Stap 4 · Bevestiging",
  "intake.step4.subtitle": "Controleer en maak de proforma aan.",
  "intake.f.customer": "Klant",
  "intake.f.customerPlaceholder": "Kies of typ een klant…",
  "intake.f.contact": "Contactpersoon",
  "intake.f.workType": "Type werk",
  "intake.f.location": "Locatie",
  "intake.f.description": "Omschrijving",
  "intake.f.descriptionPlaceholder": "Beschrijf de opdracht…",
  "intake.f.weight": "Geschat gewicht (t)",
  "intake.f.week": "Gewenste week",
  "intake.f.weekHelp": "Onder voorbehoud van planning & materieel.",
  "intake.summaryTitle": "Samenvatting",
  "intake.create": "Proforma aanmaken",

  // ── Status labels (8 states) ──────────────────────────────────────────────
  "status.concept": "Concept",
  "status.submitted": "Ingediend",
  "status.review": "In behandeling",
  "status.approved": "Goedgekeurd",
  "status.inprogress": "In uitvoering",
  "status.completed": "Gereed",
  "status.onhold": "Geblokkeerd",
  "status.rejected": "Afgewezen",

  // ── Work types ────────────────────────────────────────────────────────────
  "workType.industrialRelocation": "Industriële verplaatsing",
  "workType.machineTransport": "Machinetransport",
  "workType.lifting": "Hijswerk",
  "workType.storage": "Opslag",

  // ── User administration ───────────────────────────────────────────────────
  "users.title": "Gebruikers",
  "users.subtitle": "Beheer interne medewerkers, rollen en toegang.",
  "users.tab.all": "Alle",
  "users.tab.active": "Actief",
  "users.tab.inactive": "Inactief",
  "users.search": "Zoek op naam of e-mail…",
  "users.filter.role": "Alle rollen",
  "users.col.user": "Gebruiker",
  "users.col.roles": "Rollen",
  "users.col.status": "Status",
  "users.col.lastLogin": "Laatste login",
  "users.col.created": "Aangemaakt",
  "users.status.active": "Actief",
  "users.status.inactive": "Inactief",
  "users.neverLoggedIn": "Nog niet ingelogd",
  "users.count": "{{shown}} van {{total}} gebruikers",
  "users.pageOf": "{{page}} / {{pages}}",
  "users.empty.title": "Geen gebruikers gevonden",
  "users.empty.desc": "Pas je zoekopdracht of filter aan.",
  "users.edit.title": "Gebruiker bewerken",
  "users.edit.status": "Status",
  "users.edit.activeLabel": "Account actief",
  "users.edit.selfHint": "Je kunt je eigen account niet deactiveren.",
  "users.edit.roles": "Rollen",
  "users.edit.rolesHint": "Bepaalt tot welke onderdelen deze gebruiker toegang heeft.",
  "users.edit.details": "Details",
  "users.edit.kv.userId": "Gebruikers-ID",
  "users.edit.kv.lastLogin": "Laatste login",
  "users.edit.kv.created": "Aangemaakt",
  "users.edit.save": "Opslaan",
  "users.error.generic": "De gebruiker kon niet worden bijgewerkt. Probeer het opnieuw.",
  "users.error.selfDeactivation": "Je kunt je eigen account niet deactiveren.",
  "users.error.lastAdmin": "Er moet minstens één actieve beheerder overblijven.",

  // ── Partys (parties: customers, branches, partners) ──────────────────
  "parties.title": "Partijen",
  "parties.subtitle": "Beheer klanten, vestigingen en partners — de eigenaren van de gegevens.",
  "parties.new": "Nieuwe partij",
  "parties.tab.all": "Alle",
  "parties.tab.active": "Actief",
  "parties.tab.inactive": "Inactief",
  "parties.search": "Zoek op naam of code…",
  "parties.col.name": "Naam",
  "parties.col.code": "Code",
  "parties.col.status": "Status",
  "parties.col.created": "Aangemaakt",
  "parties.status.active": "Actief",
  "parties.status.inactive": "Inactief",
  "parties.empty.title": "Geen partijen",
  "parties.empty.desc": "Er zijn nog geen partijen die aan de filters voldoen. Maak er een aan om te beginnen.",
  "parties.count": "{{shown}} van {{total}}",
  "parties.pageOf": "Pagina {{page}} van {{pages}}",
  "parties.create.title": "Nieuwe partij",
  "parties.create.save": "Aanmaken",
  "parties.edit.title": "Partij bewerken",
  "parties.edit.save": "Opslaan",
  "parties.edit.status": "Status",
  "parties.edit.activeLabel": "Partij is actief",
  "parties.edit.activeHelp": "Een inactieve partij wordt door de intake geweigerd — er kunnen geen nieuwe proforma's binnenkomen.",
  "parties.edit.details": "Gegevens",
  "parties.edit.kv.id": "ID",
  "parties.edit.kv.created": "Aangemaakt",
  "parties.edit.kv.updated": "Laatst gewijzigd",
  "parties.field.name": "Naam",
  "parties.field.namePlaceholder": "bv. Tata Steel",
  "parties.field.code": "Code",
  "parties.field.codePlaceholder": "bv. TATA",
  "parties.field.codeHelp": "2–20 tekens: hoofdletters, cijfers, streepje of underscore. Dit is de intake-sleutel.",
  "parties.field.codeLockedHelp": "De code is de intake-sleutel en kan niet worden gewijzigd.",
  "parties.error.duplicate": "Er bestaat al een partij met deze code.",
  "parties.error.validation": "Controleer de ingevulde velden.",
  "parties.error.generic": "De partij kon niet worden opgeslagen. Probeer het opnieuw.",
  "emailSuggest.header": "Eerder gebruikt bij deze klant",
  "emailList.remove": "{{email}} verwijderen",
  "emailList.addAnother": "Nog een adres toevoegen…",
  "emailAddresses.title": "E-mailadressen",
  "emailAddresses.subtitle": "De adressen waar proforma's naartoe zijn gestuurd, per klant. Ze worden bij het versturen voorgesteld; deactiveer een fout of oud adres om dat te stoppen.",
  "emailAddresses.tab.all": "Alle",
  "emailAddresses.tab.active": "Actief",
  "emailAddresses.tab.inactive": "Gedeactiveerd",
  "emailAddresses.search": "Zoek op adres of klant…",
  "emailAddresses.since.label": "Laatst gebruikt",
  "emailAddresses.since.all": "Altijd",
  "emailAddresses.since.month": "Deze maand",
  "emailAddresses.since.prevMonth": "Sinds vorige maand",
  "emailAddresses.since.90d": "Laatste 90 dagen",
  "emailAddresses.col.party": "Klant",
  "emailAddresses.col.email": "E-mailadres",
  "emailAddresses.col.count": "Verstuurd",
  "emailAddresses.col.first": "Eerst gebruikt",
  "emailAddresses.col.last": "Laatst gebruikt",
  "emailAddresses.col.status": "Status",
  "emailAddresses.status.active": "Actief",
  "emailAddresses.status.inactive": "Gedeactiveerd",
  "emailAddresses.deactivate": "Deactiveren",
  "emailAddresses.activate": "Activeren",
  "emailAddresses.empty.title": "Geen e-mailadressen",
  "emailAddresses.empty.desc": "Een adres komt hier zodra er een proforma naartoe is gestuurd.",
  "emailAddresses.error": "Het adres kon niet worden bijgewerkt. Probeer het opnieuw.",

  // ── Roles ─────────────────────────────────────────────────────────────────
  "role.admin": "Beheerder",
  "role.planner": "Planner",
  "role.calculation": "Calculatie",
  "role.customerService": "Klantenservice",
  "role.qhse": "QHSE",
  "role.field": "Buitendienst",
  "role.projectLead": "Projectverantwoordelijke",

  // ── Proforma module (tariff lines, lifecycle) ─────────────────────────────
  "common.edit": "Bewerken",
  "common.delete": "Verwijderen",
  "common.save": "Opslaan",

  "status.draft": "Concept",
  "status.inReview": "Ter controle",
  "status.reviewed": "Gecontroleerd",
  "status.sent": "Verstuurd",
  "status.invoiced": "Gefactureerd",
  "status.manuallyInvoiced": "Handmatig gefactureerd",

  "section.labor": "Inzet",
  "section.equipment": "Hulpmateriaal",
  "section.transport": "Transport",
  "section.shipping": "Expeditie",
  "section.lifting": "Hijswerk",
  "section.rental": "Verhuur",
  "section.other": "Overige",

  "vat.standard": "BTW per regel",
  "vat.verlegd": "BTW verlegd",
  "vat.icp": "Diensten buitenland (ICP)",
  "customerDetail.full": "Alle regels",
  "customerDetail.fullHint": "Elke tariefregel met aantal, tarief en bedrag.",
  "customerDetail.sections": "Subtotalen",
  "customerDetail.sectionsHint": "Eén bedrag per onderdeel (Inzet, Transport, …), met btw en totaal.",
  "customerDetail.total": "Alleen totaal",
  "customerDetail.totalHint": "Alleen het totaalbedrag met btw.",

  "proformas.orderRef": "Ordernr {{nr}}",
  "proformas.col.work": "Werkzaamheden",
  "proformas.col.order": "Opdrachtnr",
  "proformas.col.total": "Bedrag (excl. btw)",
  "proformas.col.sent": "Verstuurd",
  "proformas.col.sentSkipped": "Niet naar de klant verstuurd — direct gereed gemeld voor facturatie",
  "proformas.tab.draft": "Te beoordelen",
  "proformas.tab.inReview": "Ter controle",
  "proformas.tab.reviewed": "Gecontroleerd",
  "proformas.tab.sent": "Verstuurd",
  "proformas.tab.rejected": "Afgewezen",
  "proformas.tab.approved": "Goedgekeurd",
  "proformas.tab.invoiced": "Gefactureerd",
  "proformas.tab.manuallyInvoiced": "Handmatig",

  "detail.titleEdit": "Titel aanpassen",
  "detail.titleLabel": "Titel van de opdracht",
  "detail.titleHint": "Komt uit de omschrijving van de eerste activiteit in TALIS. Deze titel staat boven de proforma en op de PDF naar de klant.",
  "detail.titleError": "Titel opslaan mislukt. Probeer het opnieuw.",

  "detail.weekOf": "week van {{date}}",
  "detail.period": "periode {{from}} t/m {{to}}",
  "detail.periodDay": "datum {{date}}",
  "detail.pdfSoon": "PDF-generatie volgt in een volgende stap.",
  "detail.pdfLoading": "PDF…",
  "detail.pdfError": "PDF genereren mislukt. Probeer het opnieuw.",
  "detail.send": "Verstuur proforma",
  "detail.sendConfirm": "Versturen",
  "detail.sendBody": "De proforma wordt als PDF naar de klant gemaild en TALIS wordt bijgewerkt (verstuurd).",
  "detail.sendRecipientLabel": "E-mailadressen klant",
  "detail.sendRecipientHelp": "Vooraf ingevuld met het inkoopadres van de klant. Voeg adressen toe met Enter of een komma; iedereen krijgt dezelfde mail met dezelfde link, en wie het eerst reageert, beslist. Wijzig het adres op de proforma om het te bewaren.",
  "detail.sendNoteLabel": "Toelichting (optioneel)",
  "detail.sendNoteHelp": "Komt in de e-mail aan de klant, onder de regel met het totaalbedrag.",
  "detail.sendReferenceLabel": "Referentie / inkoopnummer (optioneel)",
  "detail.sendReferenceHelp": "Al bekend? Vul hem hier één keer in. De klant ziet hem ingevuld bij het goedkeuren en kan hem nog aanpassen; pas na goedkeuring gaat hij naar TALIS.",
  "detail.sendFromLabel": "Afzender",
  "detail.sendFromSelf": "Vanuit mijn eigen mailbox versturen, met {{lead}} in CC",
  "detail.sendFromLeadHelp": "De e-mail gaat uit vanuit de mailbox van {{lead}} (projectverantwoordelijke).",
  "detail.sendFromSelfHelp": "De e-mail gaat uit vanuit {{me}}; de projectverantwoordelijke krijgt een kopie.",
  "detail.sendFromAdminHelp": "Er is geen projectverantwoordelijke met een e-mailadres, dus de e-mail gaat uit vanuit administratie.",
  "detail.sendNoLines": "Voeg eerst tariefregels toe.",
  "detail.registerApprove": "Akkoord registreren",
  "detail.registerReject": "Afwijzing registreren",
  "detail.rejectedBy": "Afgewezen door klant:",
  "detail.approvedWith": "Akkoord van klant · referentie {{reference}}",
  "detail.readyForInvoicing": "Gereed voor facturatie",
  "detail.readyForInvoicingBody": "Voor als het inkoopnummer al bekend is: de klant krijgt géén proforma gemaild. De referentie en de tariefregels gaan direct naar TALIS voor facturatie.",
  "detail.readyForInvoicingRefHelp": "Laat leeg om het TALIS-ordernummer als referentie mee te sturen.",
  "detail.readyForInvoicingConfirm": "Gereed melden",
  "detail.readyForInvoicingDone": "Gereed voor facturatie · referentie {{reference}} · niet naar de klant verstuurd",
  "detail.card.tariff": "Tariefregels",
  "detail.card.details": "Gegevens",
  "detail.tariffEmpty": "Nog geen tariefregels.",
  "detail.addLine": "Regel toevoegen",
  "detail.editLine": "Regel bewerken",
  "detail.timeline.refresh_requested": "Verversing aangevraagd bij TALIS ({{count}} activiteit(en))",
  "detail.timeline.intake_reconciled": "Tariefregels bijgewerkt uit TALIS ({{count}} regel(s), {{removed}} vervallen)",
  "detail.timeline.intake_appended": "Tariefregels bijgewerkt uit TALIS ({{count}} regel(s))",
  "detail.timeline.line_added": "Regel toegevoegd — {{line}}",
  "detail.timeline.line_changed": "Regel gewijzigd — {{line}}",
  "detail.timeline.line_removed": "Regel verwijderd — {{line}}",
  "detail.timeline.line_moved": "Regel verplaatst — {{line}}",
  "detail.timeline.updated": "Proforma gewijzigd",
  "detail.field.title": "Titel",
  "detail.field.reviewer": "Controle door",
  "detail.field.contactEmail": "E-mail klant",
  "detail.field.contactName": "Contactpersoon",
  "detail.field.projectLead": "Projectverantwoordelijke",
  "detail.field.locationText": "Locatie",
  "detail.field.vatMode": "BTW-modus",
  "detail.field.customerDetail": "Weergave voor de klant",

  "detail.field.description": "Omschrijving",
  "detail.field.section": "Sectie",
  "detail.field.kind": "Soort",
  "detail.field.quantity": "Aantal",
  "detail.field.unit": "Eenheid",
  "detail.field.unitTariffCents": "Tarief",
  "detail.field.pricePer": "Prijs per",
  "detail.field.amountCents": "Bedrag",
  "detail.field.vatCode": "BTW",
  "detail.field.employee": "Medewerker",
  "detail.field.vehicle": "Kenteken",
  "detail.field.date": "Datum",
  "detail.field.beginMin": "Van",
  "detail.field.endMin": "Tot",
  "detail.field.pauseMin": "Pauze",
  "detail.field.totalMin": "Uren",
  "detail.refresh": "Ververs uit TALIS",
  "detail.refreshTitle": "Vraag de tariefregels opnieuw op bij TALIS — regels die daar later zijn toegevoegd komen dan alsnog binnen.",
  "detail.refreshPending": "Aanvragen…",
  "detail.refreshRequested": "Verversing aangevraagd voor {{count}} activiteit(en). TALIS antwoordt binnen ongeveer een minuut; de regels verschijnen vanzelf.",
  "detail.refreshWarn.title": "Correcties gaan verloren",
  "detail.refreshWarn.intro": "Je hebt {{count}} TALIS-regel(s) zelf aangepast. Verversen zet ze terug op wat TALIS nu zegt:",
  "detail.refreshWarn.hint": "Moet een correctie blijven? Pas hem dan eerst in TALIS aan, of ververs niet.",
  "detail.refreshWarn.confirm": "Toch verversen",
  "detail.refreshError": "Verversen is niet gelukt. Probeer het opnieuw of controleer de koppeling met TALIS.",
  "detail.lineNotDeletable": "Een TALIS-regel kan niet verwijderd worden — zet 'm op 0.",
  "detail.subtotal": "Subtotaal {{section}}",
  "detail.totals.subtotal": "Subtotaal (excl. btw)",
  "detail.totals.vat": "BTW",
  "detail.totals.total": "Totaal (incl. btw)",
  "detail.line.date": "Datum",
  "detail.line.groupPlacement": "Plaatsing",
  "detail.line.groupWhat": "Wat is het",
  "detail.line.groupMoney": "Wat kost het",
  "detail.line.dragNoGroup": "Deze regel is zijn eigen tariefkop — er is niets om hem tegenover te ordenen",
  "detail.line.groupNone": "Er is nog geen tariefkop op deze proforma, dus deze regel wordt er zelf een. In TALIS is dat een nieuwe te factureren eenheid.",
  "detail.line.dragHint": "Sleep om de volgorde binnen deze tariefkop te wijzigen",
  "detail.line.insertHere": "Regel hier invoegen",
  "detail.line.newLine": "Nieuwe regel",
  "detail.line.moveRefused": "Verplaatsen lukte niet. Een tariefregel kan alleen binnen zijn eigen tariefkop van plek wisselen — TALIS kan een regel niet verplaatsen.",
  "detail.gridHint": "Klik in een veld om te bewerken · sleep aan de greep om te ordenen · + tussen twee regels voegt in",
  "detail.line.dateFromActivity": "Datum van activiteit {{id}} — vastgelegd in TALIS",
  "detail.line.dateNone": "Geen activiteit gekoppeld",
  "detail.line.employee": "Naam",
  "detail.line.vehicle": "Kenteken",
  "detail.line.work": "Werkzaamheden",
  "detail.line.hours": "Uren",
  "detail.line.qty": "Aantal",
  "detail.line.tariff": "Tarief",
  "detail.line.vat": "BTW",
  "detail.line.amount": "Bedrag",
  "detail.line.group": "Hoort bij",
  "detail.line.activity": "activiteit",
  "detail.line.groupNew": "Nieuwe tariefkop",
  "detail.line.groupHint": "De regel komt onder dit opdrachttarief te staan, ook in TALIS.",
  "detail.line.groupNewHint": "TALIS maakt een nieuwe tariefkop aan — de regel staat dan los van de bestaande opdrachttarieven.",
  "detail.line.section": "Sectie",
  "detail.line.kind": "Type",
  "detail.line.unit": "Eenheid",
  "detail.line.amountComputed": "Berekend uit aantal × tarief",
  "detail.line.amountRecalc": "Herbereken naar {{amount}}",
  "detail.kind.tariff": "Tarief",
  "detail.kind.surcharge": "Toeslag",
  "detail.merge": "Samenvoegen",
  "detail.mergeConfirm": "Samenvoegen",
  "detail.mergeBody": "De tariefregels van {{number}} verhuizen naar {{target}}. De activiteiten blijven daarna op deze proforma staan, ook na een verversing uit TALIS.",
  "detail.mergeWarning": "{{number}} verdwijnt hierna. Komt er later een nieuwe activiteit in die week binnen, dan krijgt die weer een eigen proforma.",
  "detail.mergeError": "Samenvoegen is niet gelukt. Beide proforma's moeten dezelfde order en BTW-instelling hebben, en de bron moet een concept zijn dat nooit verstuurd is.",
  "detail.contactTitle": "Ontvanger van de proforma",
  "detail.contactEmail": "E-mailadres",
  "detail.contactHint": "TALIS heeft niet altijd de juiste inkoop-contactpersoon. Dit adres wordt gebruikt bij het versturen.",
  "detail.contactError": "Opslaan is niet gelukt. Controleer het e-mailadres.",
  "detail.noContactEmail": "Geen e-mailadres bekend",
  "detail.kv.sameOrder": "Zelfde order",
  "detail.sameOrderHint": "Eén order krijgt per week een eigen proforma.",
  "detail.kv.order": "TALIS-ordernr",
  "detail.kv.vatMode": "BTW-instelling",
  "detail.kv.customerDetail": "Weergave voor de klant",
  "detail.kv.reference": "Referentie",
  "detail.referenceLabel": "Referentie / inkoopnummer",
  "detail.referenceEdit": "Referentie wijzigen",
  "detail.referenceEditSentHelp": "De klant ziet hem ingevuld bij het goedkeuren en kan hem nog aanpassen; pas na goedkeuring gaat hij naar TALIS. Er gaat geen nieuwe mail naar de klant.",
  "detail.referenceEditError": "Opslaan is niet gelukt. Probeer het opnieuw.",
  "detail.referencePlaceholder": "bijv. PO-2026-1234",
  "detail.referenceHelp": "Verplicht. Wordt teruggekoppeld naar TALIS voor facturatie.",
  "detail.rejectReasonLabel": "Reden van afwijzing",
  "detail.rejectReasonHelp": "Verplicht. Alleen intern in AvdS — er gaat geen bericht naar TALIS.",
  "detail.markManuallyInvoiced": "Handmatig gefactureerd",
  "detail.markManuallyInvoicedTitle": "Deze opdracht is buiten de proforma om in TALIS gefactureerd",
  "detail.markManuallyInvoicedBody": "Deze opdracht is in TALIS op de oude manier gefactureerd. De proforma gaat uit de werkvoorraad en krijgt de status Handmatig gefactureerd. Er gaat niets naar de klant en er wordt niets naar TALIS teruggeschreven. Dit is niet terug te draaien.",
  "detail.markInvoiced": "Markeer als gefactureerd",
  "detail.markInvoicedBody": "De proforma is goedgekeurd en teruggekoppeld aan TALIS. Markeer als gefactureerd om af te ronden in AvdS.",
  "detail.vatReverseHelp": "BTW is verlegd op proformaniveau — geen regelafwijking mogelijk.",
  "detail.actionFailed": "Actie mislukt. Probeer het opnieuw.",
  // A fold always holds at least two entries (TIMELINE_MIN_RUN), so no singular.
  "detail.timeline.foldShow": "{{count}} wijzigingen tonen",
  "detail.timeline.foldHide": "{{count}} wijzigingen verbergen",
  "detail.timelineEmpty": "Nog geen gebeurtenissen.",

  "intake.f.title": "Titel",
  "intake.f.contactEmail": "Contact e-mail",
  "intake.failed": "Aanmaken mislukt. Probeer het opnieuw.",

  "dashboard.kpi.toReview": "Te beoordelen",
  "dashboard.kpi.awaitingRef": "Wacht op referentie",
  "dashboard.kpi.rejected": "Afgewezen",
  "dashboard.kpi.approved": "Goedgekeurd",
  "dashboard.queue.toReview": "Wacht op mijn beoordeling",
  "dashboard.queue.awaitingRef": "Verstuurd — wacht op referentie",
  "dashboard.queueEmpty": "Niets in deze bak.",
  "dashboard.rejectedAlert": "{{count}} proforma(’s) afgewezen door de klant — herziening nodig. ",
  "dashboard.rejectedLink": "Bekijk afgewezen",
  "dashboard.inReviewAlert": "{{count}} proforma(’s) ter controle (vier ogen). ",
  "dashboard.inReviewLink": "Bekijk ter controle",

  // ── Vier-ogenprincipe ──────────────────────────────────────────────────
  "review.submit": "Voorleggen ter controle",
  "review.submitConfirm": "Voorleggen",
  "review.submitIntro": "Een collega controleert de proforma voordat hij naar de klant gaat. Standaard is dat de projectverantwoordelijke.",
  "review.submitIntroSelf": "Je bent zelf projectverantwoordelijke. Kies een collega die de proforma controleert.",
  "review.submitIntroNoLead": "Deze proforma heeft geen projectverantwoordelijke met toegang. Kies een collega die hem controleert.",
  "review.submitLeadHint": "Projectverantwoordelijke",
  "review.submitNoteHelp": "Optioneel. Komt in de melding aan de controleur.",
  "review.noteLabel": "Opmerking",
  "review.reviewer": "Controle door",
  "review.reviewerTitle": "Controleur wijzigen",
  "review.reviewerIntro": "Bijvoorbeeld als de controleur afwezig is. De nieuwe controleur krijgt een melding.",
  "review.requestedBy": "Voorgelegd door {{name}}",
  "review.reviewedBy": "Gecontroleerd door {{name}}",
  "review.someone": "een collega",
  "review.approve": "Akkoord",
  "review.approveAndSend": "Akkoord en versturen",
  "review.approveBody": "Je hebt de proforma van {{asker}} gecontroleerd en akkoord bevonden. Daarna kan iedereen hem versturen.",
  "review.return": "Terugsturen",
  "review.returnIntro": "De proforma gaat terug naar {{asker}}, met je opmerking.",
  "review.returnIntroEdited": "Je hebt de proforma aangepast. Hij gaat terug naar {{asker}}, zodat die je aanpassingen ziet voordat hij verstuurd wordt.",
  "review.returnNoteHelp": "Verplicht. {{asker}} krijgt hem in een melding en ziet hem op de proforma.",
  "review.withdraw": "Intrekken",
  "review.withdrawIntro": "De proforma gaat terug naar concept, zodat je hem weer kunt aanpassen. Daarna leg je hem opnieuw voor.",
  "review.reopen": "Heropenen",
  "review.reopenBody": "De proforma gaat terug naar concept. Na een aanpassing moet hij opnieuw gecontroleerd worden.",
  "review.returnedBanner": "Teruggestuurd na controle:",
  "review.exemptBanner": "Vast tarief en niet aangepast: deze proforma mag zonder controle verstuurd worden.",
  "review.exemptSentBanner": "Deze proforma is al eerder naar de klant verstuurd: na een wijziging is geen nieuwe controle nodig.",
  "review.bannerAsker": "Ligt ter controle bij {{reviewer}}. Wil je toch iets aanpassen, trek hem dan in.",
  "review.bannerReviewer": "{{asker}} vraagt je deze proforma te controleren. Pas je iets aan, dan stuur je hem daarna terug.",
  "review.bannerEdited": "Je hebt aanpassingen gedaan. Stuur de proforma terug, zodat {{asker}} ze ziet voordat hij verstuurd wordt.",
  "review.bannerReviewed": "Gecontroleerd door {{name}} op {{date}}. De proforma kan naar de klant.",
  "review.timelineSubmitted": "Ter controle bij {{reviewer}}",
  "review.timelineEdited": "met aanpassingen",
  "review.cause.review_returned": "Teruggestuurd na controle",
  "review.cause.review_withdrawn": "Controle ingetrokken",
  "review.cause.talis_changed": "Terug naar concept: TALIS wijzigde de regels",
  "review.cause.review_skipped": "Gereed voor facturatie, zonder controle",
  "review.skipReasonLabel": "Zonder vier-ogencontrole: waarom?",
  "review.skipReasonPlaceholder": "Bijv. vaste klant, controle niet nodig",
  "review.skipReasonHelp": "Verplicht. Deze proforma is niet door een collega gecontroleerd; de reden komt in de tijdlijn.",

  // Projectverantwoordelijke — uit TALIS (ord_orders), te wijzigen in AvdS. Wie
  // geen toegang heeft, laat diens proforma's in ieders werkvoorraad staan.
  "lead.filterLabel": "Toon proforma's van",
  "lead.filter.mine": "Mijn werkvoorraad",
  "lead.filter.all": "Alle proforma's",
  "lead.filter.none": "Zonder projectverantwoordelijke met toegang",
  "lead.filter.person": "Projectverantwoordelijke",
  "lead.none": "niemand",
  "lead.unassigned": "geen projectverantwoordelijke",
  "lead.nobodyTitle": "Niemand toegewezen",
  "lead.noAccess": "geen toegang",
  "lead.hint.none": "Geen projectverantwoordelijke in TALIS. Staat in ieders werkvoorraad.",
  "lead.hint.noAccess": "Heeft geen toegang tot AvdS. Staat in ieders werkvoorraad.",
  "lead.hint.manual": "Hier gewijzigd. Volgens TALIS: {{talis}}.",
  "lead.emptyMine.title": "Je werkvoorraad is leeg",
  "lead.emptyMine.desc": "Hier staan jouw proforma's en die van wie geen toegang heeft.",
  "lead.showAll": "Toon alle proforma's",
  "lead.emptyScoped.mine": "Er is alleen gezocht in je werkvoorraad.",
  "lead.emptyScoped.none": "Er is alleen gezocht in de proforma's zonder projectverantwoordelijke met toegang.",
  "lead.emptyScoped.person": "Er is alleen gezocht in de proforma's van {{name}}.",
  "lead.modal.title": "Projectverantwoordelijke",
  "lead.modal.intro": "Bepaalt in wiens werkvoorraad deze proforma staat. De klant en TALIS merken er niets van.",
  "lead.modal.talis": "Volgens TALIS: {{name}}",
  "lead.modal.talisHint": "Volgt TALIS, ook als de order daar later een andere krijgt.",
  "lead.modal.error": "Wijzigen is niet gelukt. Probeer het opnieuw.",

  // ── List tables: columns, sort, filters, pages (components/table) ───────────
  "columns.button": "Kolommen",
  "columns.buttonHint": "Kies welke kolommen je ziet en in welke volgorde",
  "columns.title": "Kolommen",
  "columns.alwaysShown": "altijd zichtbaar",
  "columns.hint": "Sleep een rij of een kolomkop om de volgorde te wijzigen, of gebruik Alt + ↑/↓. Sleep de rand van een kolomkop om hem breder of smaller te maken; dubbelklik op de rand om hem passend te maken. Je indeling en sortering worden bij je account bewaard.",
  "columns.reset": "Standaardindeling",
  "columns.sortBy": "Sorteer op {{column}}",
  "columns.dragHint": "Sleep om de kolom te verplaatsen",
  "columns.resize": "Breedte van {{column}}",
  "columns.resizeHint": "Sleep om de breedte te wijzigen, dubbelklik om passend te maken",
  "columns.filterBy": "Filter op {{column}}",
  "columns.filteredBy": "Gefilterd op {{column}}, klik om aan te passen",
  "columns.filterClear": "Wissen",
  "columns.filterDone": "Klaar",
  "columns.filterContains": "Bevat…",
  "columns.filterRangeFrom": "Van",
  "columns.filterRangeTo": "Tot en met",
  "columns.filterFrom": "vanaf {{value}}",
  "columns.filterUntil": "tot en met {{value}}",
  "columns.filteredOn": "Gefilterd op",
  "columns.filterRemove": "Filter op {{column}} weghalen",
  "columns.filterClearAll": "Alle filters wissen",
  "columns.unitEuro": "€",
  "pager.range": "{{first}}–{{last}} van {{total}}",
  "pager.empty": "Geen rijen",
  "pager.perPage": "Per pagina",
  "pager.previous": "Vorige pagina",
  "pager.next": "Volgende pagina",
  "pager.pageOf": "Pagina {{page}} van {{pages}}",
  "proformas.col.week": "Week van",
  "proformas.col.reference": "Referentie",
  "proformas.col.totalIncl": "Bedrag (incl. btw)",
  "proformas.col.created": "Aangemaakt",
  "proformas.emptyFiltered": "Er is alleen gezocht binnen de kolomfilters boven de tabel.",

  // Openstaande orders
  "nav.openOrders": "Openstaande orders",
  "openOrders.title": "Openstaande orders",
  "openOrders.subtitle": "Uitgevoerd, nog niet gefactureerd: alle orders van O50 (Nacalculatie) tot en met O60 (Facturabel)",
  "openOrders.syncedAt": "bijgewerkt uit TALIS {{time}}",
  "openOrders.search": "Zoek op order, opdrachtgever of opmerking",
  "openOrders.mine": "Alleen mijn orders",
  "openOrders.totalOpen": "Openstaand",
  "openOrders.noDate": "Zonder datum",
  "openOrders.monthCount_one": "{{count}} order",
  "openOrders.monthCount_other": "{{count}} orders",
  "openOrders.count": "{{shown}} van {{total}} orders",
  "openOrders.col.order": "Order",
  "openOrders.col.customer": "Opdrachtgever",
  "openOrders.col.lead": "Projectverantwoordelijke",
  "openOrders.col.talisRemarks": "Opmerkingen intern (TALIS)",
  "openOrders.col.invoiceText": "Factuurtekst",
  "openOrders.col.notes": "Interne opmerkingen",
  "openOrders.col.period": "Periode",
  "openOrders.col.revenue": "Projectomzet",
  "openOrders.col.open": "Openstaande omzet",
  "openOrders.col.state": "Status",
  "openOrders.state.label": "Status",
  "openOrders.state.all": "Alle statussen",
  "openOrders.state.O50": "Nacalculatie",
  "openOrders.state.O51": "Proforma",
  "openOrders.state.O52": "Wacht op inkoopnummer",
  "openOrders.state.O54": "Aandacht vereist",
  "openOrders.state.O60": "Facturabel",
  "openOrders.state.O70": "Afgehandeld",
  "openOrders.state.O99": "Vervallen",
  "openOrders.activities": "Activiteiten",
  "openOrders.act.id": "Activiteit",
  "openOrders.act.date": "Datum",
  "openOrders.act.invoiced": "Gefactureerd",
  "openOrders.proformas": "Proforma's",
  "openOrders.note.placeholder": "Interne opmerking toevoegen",
  "openOrders.note.add": "Opmerking toevoegen",
  "openOrders.note.delete": "Opmerking verwijderen",
  "openOrders.note.none": "Nog geen interne opmerkingen.",
  "openOrders.note.error": "Opslaan van de opmerking is mislukt. Probeer het opnieuw.",
  "openOrders.empty.title": "Geen openstaande orders",
  "openOrders.empty.desc": "Er staat geen order tussen Nacalculatie en Facturabel, of de filters sluiten alles uit.",
  // Route van een activiteit (docs/route-distance.md)
  "detail.route.km": "{{km}} km",
  "detail.route.open": "Route op de kaart",
  "detail.route.title": "Route {{ref}}",
  "detail.route.loading": "Route berekenen…",
  "detail.route.error": "De route kon niet worden berekend.",
  "detail.route.kilometers": "Kilometers",
  "detail.route.exact": "{{km}} km over de weg, afgerond op 5 naar boven",
  "detail.route.sentToTalis": "Naar TALIS gestuurd bij rit gereed, {{date}}",
  "detail.route.screenOnly": "Alleen berekend voor dit scherm. Bij rit gereed rekent AvdS opnieuw en gaan de kilometers naar TALIS.",
  "detail.route.role.home": "Thuis",
  "detail.route.role.load": "Laden",
  "detail.route.role.unload": "Lossen",
  "detail.route.source.talis": "TALIS",
  "detail.route.source.here": "HERE",
  "detail.route.reason.not_configured": "HERE is niet ingesteld",
  "detail.route.reason.no_address": "Geen adres op de activiteit",
  "detail.route.reason.load_not_found": "Laadadres niet gevonden",
  "detail.route.reason.unload_not_found": "Losadres niet gevonden",
  "detail.route.reason.home_not_found": "Thuisadres niet gevonden",
} as const;
